import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2296b595"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 wrapper-info" }
const _hoisted_2 = { class: "row row-cast" }
const _hoisted_3 = { class: "col-6 panel cryptocola block" }
const _hoisted_4 = { class: "panel-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You have", -1))
const _hoisted_6 = { class: "cola-count" }
const _hoisted_7 = { class: "panel-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Now you have accumulated", -1))
const _hoisted_9 = { class: "title-info" }
const _hoisted_10 = { class: "cola-count" }
const _hoisted_11 = { class: "col-6 panel block" }
const _hoisted_12 = { class: "panel-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You can rename a squad for", -1))
const _hoisted_14 = { class: "cola-count" }
const _hoisted_15 = { class: "panel-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You can set a squad slogan for", -1))
const _hoisted_17 = { class: "cola-count" }
const _hoisted_18 = { class: "panel-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Gather yourself another squad, buy a cell for", -1))
const _hoisted_20 = { class: "cola-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.colaBalance) + " $CyberCola", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.claimableCola) + " $CYBERCOLA", 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.dailyIncome) + " $CYBERCOLA/Day", 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cyberSquadClaim())),
          class: "button fourth"
        }, " Withdraw all ")
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.rename) + " $CyberCola", 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.slogan) + " $CyberCola", 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.amountDay) + " $CyberCola", 1)
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.extendSquadesAmount && _ctx.extendSquadesAmount(...args))),
          class: "button primary"
        }, " Buy +1 Squade ")
      ])
    ])
  ]))
}